<template>
  <div class="create-password-container">
    <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions"></OnboardingMenu>
    <div class="banner">
      <img :src="bannerUrl" alt="">
    </div>
    <onboarding-message class="message" :messages="messages"></onboarding-message>
    <div class="title">{{ $t('onboarding.common.loginTitle') }}</div>
    <onboarding-divider />
    <div class="input-form-div">
      <onboarding-input ref="userName" :label="$t('onboarding.nestle.userName')" isRequired="true" v-model="userName"/>
      <onboarding-input ref="password" :label="$t('onboarding.nestle.password')" isRequired="true" v-model="password" type='password'/>
      <!-- <a
        class="forget-password-link row visible-on col-md-8 col-lg-5 col-md-offset-1 col-lg-offset-3"
        @click="handleForgetPassword">
        {{ $t('onboarding.common.btn.forgetPassword') }}
      </a> -->
    </div>
    <div class="agreement-policy">
      <el-checkbox v-model="policy" class="policy-checkbox" ></el-checkbox>
      <div class="policy-container">
        <div class="policy" :class="isEn && 'is-en'">
          <span>{{ $t('login.company.register.candidate.policy.body') }}</span>
          <a class="policy-link" href="/tos/" target="_blank">{{ $t('login.company.register.candidate.policy.link1') }}</a>
          <span>& </span>
          <a class="policy-link" href="/policy/" target="_blank">{{ $t('login.company.register.candidate.policy.link2') }}</a>
        </div>
      </div>
      <span v-if="showPolicyTips" class="tips">{{ policyErrorTips }}</span>
    </div>
    <div class="input-form-div">
      <a
        class="forget-password-link row visible-on col-md-8 col-lg-5 col-md-offset-1 col-lg-offset-3"
        @click="handleForgetPassword">
        {{ $t('onboarding.common.btn.forgetPassword') }}
      </a>
    </div>
    <div class="next-button">
      <onboarding-button @click.native="login" :text="$t('onboarding.nestle.toEmployeePortal')" type='normal'></onboarding-button>
    </div>
  </div>
</template>
<script>
import OnboardingInput from '@/components/onboarding/form/Input'
import OnboardingButton from '@/components/onboarding/form/Button'
import OnboardingMessage from '@/components/onboarding/form/Message'
import OnboardingDivider from '@/components/onboarding/form/Divider'
import { mapActions } from 'vuex'
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import { deviceType } from '@/utils/common'
import { passwordEncrypt } from '@/utils/rsa'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingInput, OnboardingButton, OnboardingMessage, OnboardingDivider, OnboardingMenu
  },
  data () {
    return {
      userName: '',
      password: '',
      bannerUrl: '',
      policy: false,
      showPolicyTips: false
    }
  },
  computed: {
    isNestle () {
      return this.$parent.isNestle
    },
    policyErrorTips () {
      if (!this.policy) {
        return this.$t('common.message.needLoginAgreePolicy')
      }
      return ''
    }
  },
  async created () {
    const queryStr = window.location.search
    const queryArr = queryStr.substr(1).split('&')
    queryArr.forEach(item => {
      if (item.includes('email=')) {
        const emailArr = item.split('email=')
        if (emailArr.length > 1) {
          this.userName = window.decodeURIComponent(emailArr[1])
        }
      }
    })
    this.initBannerUrl()
  },
  methods: {
    ...mapActions('onboarding', ['loginAccount']),
    ...mapActions('account', ['getSessionAccountInfo']),
    initBannerUrl () {
      if (this.isNestle) {
        if (deviceType.isMobile) {
          this.bannerUrl = require('@/assets/image/onboarding/common/mobile-banner.jpg')
        } else {
          this.bannerUrl = require('@/assets/image/onboarding/common/banner.png')
        }
      } else {
        this.bannerUrl = this.$parent.headerImage
      }
    },
    async login () {
      if (!this.$refs.userName.validate() || !this.$refs.password.validate()) {
        return
      }
      if (!this.policy) {
        this.showPolicyTips = !this.policy
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.loginAccount({ userName: this.userName, password: passwordEncrypt(this.password) })
        if (resp) {
          await this.getSessionAccountInfo()
          await this.$parent.refreshInvitationInfo()
          this.$router.push(this.$parent.getOnboardingHomePath())
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleForgetPassword () {
      this.$router.push(`/onboarding/${this.invitationId}/forget-password`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
  .create-password-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .banner {
      img {
        background-size: cover;
        width: 100%;
        height: auto;
      }
    }
    .message {
      position: fixed;
      top: 50px;
    }
    .title {
      font-weight: bolder;
      margin-top: 2rem;
      margin-bottom: 1.2rem;
      text-align: center;
    }
    .divider {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2.5rem;
      float: none;
    }
    .input-form-div {
      width: 100%;
      padding: 0 5%;
      .forget-password-link {
        display: block;
        text-align: right;
        font-size: 14px;
        padding-top: 15px;
      }
    }
    .agreement-policy {
      flex: 1;
      margin-top: 10px;
      margin-bottom: 70px;
      position: relative;
      width: 25%;
      .policy-link {
        color: #0096cc;
      }

      .policy-checkbox {
        position: absolute;
        left: 10px;
        ::v-deep {
          .el-checkbox__input {
            line-height: 0;
            &.is-checked {
              .el-checkbox__inner {
                background-color: #fff;
                border-color: #b2b2b2;
              }
            }

            &.is-focus {
              .el-checkbox__inner {
                border-color: #b2b2b2;
              }
            }
            .el-checkbox__inner {
              width: 16px;
              height: 16px;
              border-color: #b2b2b2;
              border-radius: 0;

              &:hover {
                border-color: #b2b2b2;
              }

              &::after {
                width: 6px;
                height: 14px;
                border-width: 3px;
                border-color: #4d4d4d;
                top: -4px;
                left: 3px;
              }
            }
          }
        }
      }
      .policy-container{
        position: absolute;
        left: 50px;
        height: 16px;
        span {
          font-size: 16px;
        }
        a {
          font-size: 16px;
        }
        .policy {
          line-height: normal;
          width: 380px;
          height: 16px;
          line-height: 16px;
        }
      }
    }
    .policy-checkbox {
      span {
          font-size: 16px;
        }
        a {
          font-size: 16px;
        }
    }
    .tips {
      position: absolute;
      left: 20px;
      color: red;
      right: auto;
      top: 55px;
      width: 380px;
      padding-left: 30px;
      margin: 0;
      font-size: 14px;
    }

    .next-button {
        margin: 4rem 0;
        padding-bottom: 50px;
    }
  }
/* 小型设备（平板电脑，768px 起） */
@media (max-width: 768px) {
  .create-password-container {
    .agreement-policy {
      flex: 1;
      margin-top: 10px;
      margin-bottom: 70px;
      position: relative;
      width: 95%;
    }
  }
}
</style>
